import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=368e2327&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=368e2327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e2327",
  null
  
)

export default component.exports